import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getPromoSectionList() {
    const params = {};
    return api.get('promo_sections', { params: omitBy(params, isNil) });
  },
  getPromoSectionDetail(id) {
    return api.get(`promo_sections/${id}`);
  },
  createPromoSection(payload) {
    return api.post('promo_sections', payload);
  },
  updatePromoSection(id, payload) {
    return api.put(`promo_sections/${id}`, payload);
  },
  deletePromoSection(id) {
    return api.delete(`promo_sections/${id}/delete`);
  },
  reactivatePromoSection(id) {
    return api.put(`promo_sections/${id}/reactivate`);
  },
  deactivatePromoSection(id) {
    return api.delete(`promo_sections/${id}`);
  },
};
